/* Once Upon Magic — NEO 2026
   Progressive commerce motion and page targeting.
   No cart, pricing, filtering, variant or checkout business logic is modified here. */
(() => {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let cardObserver = null;

  if (!reduceMotion && 'IntersectionObserver' in window) {
    cardObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.dataset.oumNeoCard = 'visible';
          cardObserver.unobserve(entry.target);
        }
      },
      { rootMargin: '100px 0px', threshold: 0.04 }
    );
  }

  function detectPageType() {
    const path = window.location.pathname;

    if (document.querySelector('[data-testid="product-information"], product-component') || path.includes('/products/')) {
      return 'product';
    }

    if (document.querySelector('.cart-page') || path.endsWith('/cart')) {
      return 'cart';
    }

    if (path.endsWith('/search') || (document.querySelector('results-list') && document.querySelector('form[action*="/search"]'))) {
      return 'search';
    }

    if (document.querySelector('collection-component') || path.includes('/collections/')) {
      return 'collection';
    }

    return null;
  }

  function markPageHeading(type) {
    let contentSection = null;

    if (type === 'collection') {
      contentSection = document.querySelector('collection-component')?.closest('.shopify-section');
    } else if (type === 'search') {
      contentSection = document.querySelector('results-list')?.closest('.shopify-section');
    }

    const headingSection = contentSection?.previousElementSibling;
    if (headingSection?.classList.contains('shopify-section')) {
      headingSection.classList.add('oum-neo-page-heading');
    }
  }

  function prepareProductCards(scope = document) {
    if (!scope.querySelectorAll) return;

    const cards = scope.matches?.('.product-grid__item:not([data-oum-neo-card])')
      ? [scope]
      : scope.querySelectorAll('.product-grid__item:not([data-oum-neo-card])');

    cards.forEach((card, index) => {
      card.style.setProperty('--oum-card-delay', `${Math.min(index % 8, 6) * 35}ms`);

      if (reduceMotion || !cardObserver) {
        card.dataset.oumNeoCard = 'visible';
        return;
      }

      card.dataset.oumNeoCard = 'pending';
      cardObserver.observe(card);
    });
  }

  function watchDynamicResults() {
    if (!('MutationObserver' in window)) return;
    const surface = document.querySelector('#MainContent') || document.body;
    if (!surface) return;

    const mutationObserver = new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) prepareProductCards(node);
        }
      }
    });

    mutationObserver.observe(surface, { childList: true, subtree: true });
  }

  function init() {
    const type = detectPageType();
    if (type) root.classList.add(`oum-neo-page-${type}`);
    if (!reduceMotion) root.classList.add('oum-commerce-motion');

    markPageHeading(type);
    prepareProductCards();
    watchDynamicResults();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
